@if (leftPx$ | async; as leftPx) {
<div
	[style.left.px]="leftPx"
	class="pointer-events-none absolute top-0 bottom-0 z-10 w-0.5 bg-blue-500"
>
	@if (todayVisible) {
	<div
		(click)="$event.stopPropagation(); $event.preventDefault();"
		[style.height.px]="dayHeightPx - 16"
		[style.top.px]="hourLableHeightOffset + todayIndex * dayHeightPx"
		class="pointer-events-none absolute left-1/2 flex -translate-x-1/2 flex-col items-center justify-between"
	>
		@if(!(hasActiveProjecthourRecording$.value$ | async)) {
		<button
			(click)="startProjecthourRecording()"
			[matTooltip]="'timer.calendar.startProjectRecording' | translate"
			class="flex items-center gap-1 rounded border border-muted bg-background px-1.5 py-0.5 text-xs shadow pointer-events-auto"
			type="button"
		>
			<span class="size-2 rounded-full bg-yellow-400"></span>
			<span>{{ 'timer.calendar.rec' | translate }}</span>
		</button>
		} @else {
		<button
			(click)="stopProjecthourRecording()"
			[matTooltip]="'timer.calendar.startProjectRecording' | translate"
			class="flex items-center gap-1 rounded border border-muted bg-background px-1.5 py-0.5 text-xs shadow pointer-events-auto"
			type="button"
		>
			<span class="size-2 rounded-full bg-yellow-400"></span>
			<span>{{ 'timer.calendar.stop' | translate }}</span>
		</button>
		} @if(!(hasActiveWorkinghourRecording$.value$ | async)) {
		<button
			(click)="startWorkinghourRecording()"
			[matTooltip]="'timer.calendar.startWorkingRecording' | translate"
			class="flex items-center gap-1 rounded border border-muted bg-background px-1.5 py-0.5 text-xs shadow pointer-events-auto"
			type="button"
		>
			<span class="size-2 rounded-full bg-green-500"></span>
			<span>{{ 'timer.calendar.rec' | translate }}</span>
		</button>
		} @else {
		<button
			(click)="stopWorkinghourRecording()"
			[matTooltip]="'timer.calendar.startWorkingRecording' | translate"
			class="flex items-center gap-1 rounded border border-muted bg-background px-1.5 py-0.5 text-xs shadow pointer-events-auto"
			type="button"
		>
			<span class="size-2 rounded-full bg-green-500"></span>
			<span>{{ 'timer.calendar.stop' | translate }}</span>
		</button>
		}
	</div>
	}
</div>
}
